import { render, staticRenderFns } from "./DocumentThumbnail.vue?vue&type=template&id=33594f78"
import script from "./DocumentThumbnail.vue?vue&type=script&lang=js"
export * from "./DocumentThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports